import { render, staticRenderFns } from "./EditWorkplaceAssignationList.vue?vue&type=template&id=135d729e&scoped=true"
import script from "./EditWorkplaceAssignationList.vue?vue&type=script&lang=js"
export * from "./EditWorkplaceAssignationList.vue?vue&type=script&lang=js"
import style0 from "./EditWorkplaceAssignationList.vue?vue&type=style&index=0&id=135d729e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135d729e",
  null
  
)

export default component.exports